import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../../store';
import { get, post, put } from '../../../../inteceptor';
import moment from 'moment';

const initialState = {
  isLoading: false,
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};
const buildTree = (items, parentId = null) =>
  items
    .filter((item) => item.parentId === parentId || (item.parentId === null && parentId === null))
    .map((item) => ({
      ...item,
      children: buildTree(items, item.id),
    }));

const slice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET productManagement
    getTagsSuccess(state, action) {
      state.data = action.payload.data
        .map((value) => {
          return { ...value, label: value.name };
        })
        .sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0));
      state.sorted = buildTree(action.payload.data.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0)));
    },

    addOrUpdateTags(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getTags() {
  return async () => {
    try {
      const response = await get(`locations`);
      if (response.status) {
        dispatch(slice.actions.getTagsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addTag(body) {
  return async () => {
    try {
      const response = await post(`tag`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateTags(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateTag(body) {
  return async () => {
    try {
      const response = await put(`tag`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateTags(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
